import { useFormat } from '@/composables/useFormat'
import moment from 'moment'

const { formatDate, formatProtocol, formatConstructionStatus, formatStatus, formatMosType } = useFormat()

const base = {
  user: {
    route: 'user',
    title: 'Usuários',
    headers: [
      { title: 'ID', field: 'id', width: '160px' },
      { title: 'Nome', field: 'name' },
      { title: 'Localidade', field: 'localName' },
    ],
    filters: [],
  },
  group: {
    route: 'group',
    headers: [
      { title: 'ID', field: 'id', width: '160px' },
      { title: 'Nome', field: 'name' },
      { title: 'Descrição', field: 'description' },
    ],
    filters: [
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
      {
        label: 'Descrição',
        param: 'description',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite a descrição',
      },
      {
        label: 'Administrador',
        param: 'admin',
        type: 'boolean',
        placeholder: 'Selecione',
      },
    ],
  },
  screen: {
    route: 'screen',
    title: 'Programas',
    simpleSearch: true,
    headers: [
      { title: 'ID', field: 'id', width: '120px' },
      { title: 'Nome', field: 'name' },
      { title: 'Rota', field: 'screenRoute' },
    ],
    filters: [
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
      {
        label: 'Rota',
        param: 'screenRoute',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite a rota',
      },
    ],
  },
  team: {
    title: 'Equipes',
    route: 'team',
    headers: [
      { title: 'Código', field: 'id' },
      { title: 'Nome', field: 'name' },
      { title: 'Lider', field: 'leaderName', table: 'employee', orderField: 'name' },
      { title: 'Veículo', field: 'licensePlate', table: 'vehicles', orderField: 'licensePlate' },
    ],
    filters: [
      {
        label: 'Código',
        param: 'id',
        type: 'text',
        placeholder: 'Digite o código',
      },
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
      {
        label: 'Veículo',
        param: 'licensePlate',
        operator: 'like',
        type: 'veiculo',
        placeholder: 'Digite a placa do veículo',
      },
    ],
  },
  teamWarehouse: {
    title: 'Equipes',
    route: 'warehouse',
    tableFilter: [{ column: 'type', operator: '=', value: 'team' }],
    headers: [
      { title: 'Código', field: 'id' },
      { title: 'Nome', field: 'name' },
      { title: 'Lider', field: 'leaderName', table: 'employee', orderField: 'name' },
      { title: 'Veículo', field: 'licensePlate', table: 'vehicles', orderField: 'licensePlate' },
    ],
    filters: [
      {
        label: 'Código',
        param: 'id',
        type: 'text',
        placeholder: 'Digite o código',
      },
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
    ],
  },
  employee: {
    route: 'employee',
    title: 'Funcionários',
    headers: [
      { title: 'Nome', field: 'name' },
      { title: 'Cargo', field: 'role', table: 'employee_role', orderField: 'name' },
      { title: 'Matrícula', field: 'registration' },
      { title: 'Status', field: 'status', format: formatStatus },
    ],
    filters: [
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
      {
        label: 'Cargo',
        param: 'id_employee_role',
        database: 'employeeRole',
        itemText: 'name',
        itemValue: 'id',
        type: 'zoom',
        placeholder: 'Digite o cargo',
      },
      {
        label: 'Matrícula',
        param: 'registration',
        type: 'text',
        placeholder: 'Digite a matrícula',
      },
      {
        label: 'Status',
        param: 'status',
        type: 'select',
        items: [
          { label: 'Ativo', value: '1' },
          { label: 'Inativo', value: '0' },
        ],
        placeholder: 'Selecione o status',
      },
    ],
    order: [{ direction: 'ASC', column: 'name' }],
    initialFilters: [
      {
        column: 'status',
        operator: '=',
        value: 1,
      },
    ],
  },
  email: {
    route: 'employee',
    title: 'Email',
    headers: [
      { title: 'Email', field: 'email' },
      { title: 'Nome', field: 'name' },
      { title: 'Matrícula', field: 'registration' },
      { title: 'CPF', field: 'cpf' },
    ],
    filters: [
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
      {
        label: 'Email',
        param: 'email',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o email',
      },
      {
        label: 'Matrícula',
        param: 'registration',
        type: 'text',
        placeholder: 'Digite a matrícula',
      },
      {
        label: 'CPF',
        param: 'cpf',
        type: 'text',
        placeholder: 'Digite o CPF',
      },
    ],
  },
  os: {
    route: 'os',
    title: 'Ordem de Serviço',
    headers: [
      { title: 'Validado', field: 'id', width: '24px' },
      { title: 'Protocolo', field: 'protocolo', format: formatProtocol },
      { title: 'Equipe', field: 'idTeam' },
      { title: 'Serviço', field: 'idServiceRequested' },
      { title: 'Local', field: 'localName', table: 'local', orderField: 'name' },
      { title: 'Endereço', field: 'address' },
      { title: 'Bairro', field: 'neighborhood' },
      { title: 'Criação', field: 'requestedDate', format: formatDate },
      { title: 'Vencimento', field: 'expirationDate', format: formatDate },
      { title: 'Executada', field: 'performedDate', format: formatDate },
      { title: 'Status', field: 'status' },
    ],
    filters: [
      {
        label: 'Protocolo',
        param: 'protocolo',
        type: 'text',
        operator: 'like',
        placeholder: 'Digite o protocolo',
      },
      {
        label: 'Endereço',
        param: 'address',
        type: 'text',
        operator: 'like',
        placeholder: 'Digite o endereço',
      },
      {
        label: 'Unidade',
        param: 'idUnity',
        type: 'zoom',
        database: 'unity',
        itemText: 'name',
        itemValue: 'id',
        placeholder: 'Selecione a unidade',
        itemAutocomplete: ['id', 'name'],
      },
      {
        label: 'Localidade',
        param: 'idLocale',
        type: 'zoom',
        database: 'local',
        itemText: 'name',
        itemValue: 'id',
        placeholder: 'Selecione a localidade',
      },
      {
        label: 'Serviço Requisitado',
        param: 'idServiceRequested',
        type: 'zoom',
        // operator: 'in',
        database: 'service',
        itemText: 'name',
        itemValue: 'externalCode',
        itemAutocomplete: ['externalCode', 'name'],
        placeholder: 'Selecione o serviço',
      },
      {
        label: 'Equipe',
        param: 'idTeam',
        type: 'zoomMultiple',
        database: 'team',
        placeholder: 'Selecione a equipe',
        itemText: 'name',
        itemValue: 'id',
        itemAutocomplete: ['id', 'name'],
      },
      {
        label: 'Data Criação',
        param: 'requestedDate',
        type: 'range',
        operator: 'between',
        placeholder: 'Selecione o intervalo de datas',
      },
      {
        label: 'Data Executada',
        param: 'performedDate',
        type: 'range',
        operator: 'between',
        placeholder: 'Selecione o intervalo de datas',
      },
      {
        label: 'Data Vencimento',
        param: 'expirationDate',
        type: 'range',
        operator: 'between',
        placeholder: 'Selecione o intervalo de datas',
      },
      {
        label: 'Status',
        param: 'status',
        type: 'select',
        items: [
          { label: 'EXECUTADO', value: 'EXECUTADO' },
          { label: 'NÃO EXECUTADO', value: 'NÃO EXECUTADO' },
          { label: 'CRIADO VIA BOT SGC/EXTRA', value: 'CRIADO VIA BOT SGC/EXTRA' },
          { label: 'REJEITADO PELA EQUIPE', value: 'REJEITADO PELA EQUIPE' },
          { label: 'PENDENTE DE EXECUÇÃO', value: 'PENDENTE DE EXECUÇÃO' },
          { label: 'EM CAMPO', value: 'EM CAMPO' },
          { label: 'AGUARDANDO EQUIPE CONFIRMAR RECEBIMENTO', value: 'AGUARDANDO EQUIPE CONFIRMAR RECEBIMENTO' },
          { label: 'PENDENTE DE CARGA NO EQUIPAMENTO', value: 'PENDENTE DE CARGA NO EQUIPAMENTO' },
          {
            label: 'REJEITADO - SOLICITAÇÃO COM DADOS INVÁLIDOS',
            value: 'REJEITADO - SOLICITAÇÃO COM DADOS INVÁLIDOS',
          },
          { label: 'EM TRANSMISSÃO', value: 'EM TRANSMISSÃO' },
          { label: 'EM EXECUÇÃO', value: 'EM EXECUÇÃO' },
          { label: 'CANCELADO', value: 'CANCELADO' },
        ],
        placeholder: 'Selecione o status',
      },
      {
        label: 'MOS Baixado',
        param: 'idMos',
        table: 'osMos',
        type: 'zoom',
        database: 'mos',
        itemText: 'name',
        itemValue: 'code',
        itemAutocomplete: ['code', 'name'],
        placeholder: 'Selecione o MOS',
      },
      {
        label: 'Serviço Baixado',
        param: 'idService',
        table: 'osService',
        type: 'zoomMultiple',
        database: 'service',
        itemText: 'name',
        itemValue: 'externalCode',
        itemAutocomplete: ['externalCode', 'name'],
        placeholder: 'Selecione o serviço',
      },
    ],
    order: [{ direction: 'DESC', column: 'id' }],
    initialFilters: [
      {
        column: 'requestedDate',
        operator: 'between',
        value: [moment().subtract('30', 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
      },
    ],
  },
  service: {
    title: 'Serviços',
    route: 'service',
    headers: [
      { title: 'Código', field: 'externalCode' },
      { title: 'Nome', field: 'name', width: '48%' },
      { title: 'Grupo', field: 'serviceGroup' },
      // { title: 'Tipo', field: 'teamType' },
      // { title: 'Prioridade', field: 'priority' },
      // { title: 'Pontos', field: 'points' },
      // { title: 'Contrato', field: 'idContract' },
      // { title: 'Preço', field: 'price', align: 'text-center' },
    ],
    filters: [
      {
        label: 'Código',
        param: 'externalCode',
        type: 'text',
        placeholder: 'Digite o código',
      },
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
      {
        label: 'Grupo',
        param: 'idServiceGroup',
        type: 'zoom',
        database: 'serviceGroup',
        itemText: 'name',
        itemValue: 'id',
        placeholder: 'Selecione o grupo',
      },
      {
        label: 'Tipo de Equipe',
        param: 'idTeamType',
        type: 'zoom',
        database: 'teamType',
        itemText: 'name',
        itemValue: 'id',
        placeholder: 'Selecione o tipo de equipe',
      },
      {
        label: 'Setor',
        param: 'idSector',
        type: 'zoom',
        database: 'sector',
        itemText: 'name',
        itemValue: 'id',
        placeholder: 'Selecione o setor',
      },
      {
        label: 'Prioridade',
        param: 'priority',
        type: 'number',
        placeholder: 'Digite a prioridade',
      },
    ],
  },
  mos: {
    title: 'Mos',
    route: 'mos',
    headers: [
      { title: 'Código', field: 'code' },
      { title: 'Nome', field: 'name' },
      { title: 'Tipo', field: 'type', format: formatMosType },
    ],
    filters: [
      {
        label: 'Código',
        param: 'code',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o código',
      },
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
    ],
  },
  warehouse: {
    title: 'Depósito',
    route: 'warehouse',
    headers: [
      { title: 'Depósito', field: 'name' },
      { title: 'Tipo', field: 'typeName', orderField: 'type' },
      { title: 'Endereço', field: 'address' },
      { title: 'Descrição', field: 'description' },
    ],
    filters: [
      {
        label: 'Depósito',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome do depósito',
      },
      {
        label: 'Tipo',
        param: 'type',
        type: 'select',
        items: [
          { label: 'Físico', value: 'physic' },
          { label: 'Equipe', value: 'team' },
          { label: 'Veículo', value: 'vehicles' },
        ],
        placeholder: 'Selecione o tipo',
      },
      {
        label: 'Endereço',
        param: 'address',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o endereço',
      },
      {
        label: 'Descrição',
        param: 'description',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite a descrição',
      },
    ],
  },
  item: {
    title: 'Item',
    route: 'item',
    headers: [
      { title: 'Código', field: 'code' },
      { title: 'Nome', field: 'name', itemClass: '!text-wrap' },
      { title: 'Tipo', field: 'itemTypeName', table: 'itemType', orderField: 'name' },
      { title: 'Classe', field: 'itemClassName', orderField: 'name', table: 'ItemClass' },
      {
        title: 'Und de Medida',
        field: 'criterionOfMeasurementSymbol',
        table: 'criterionOfMeasurement',
        orderField: 'symbol',
      },
    ],
    filters: [
      {
        label: 'Código',
        param: 'code',
        type: 'text',
        placeholder: 'Digite o código',
      },
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
      {
        label: 'Tipo',
        param: 'idItemType',
        type: 'tipoItem',
        placeholder: 'Selecione o tipo',
      },

      {
        label: 'Critério de Medição',
        param: 'idCriterionOfMeasurement',
        type: 'criterioDeMedida',
        placeholder: 'Selecione o critério',
      },
    ],
  },
  itemWarehouse: {
    title: 'Item',
    route: 'item',
    headers: [
      { title: 'Código', field: 'code' },
      { title: 'Nome', field: 'name', itemClass: '!text-wrap' },
      { title: 'Tipo', field: 'itemTypeName', table: 'itemType', orderField: 'name' },
      { title: 'Classe', field: 'itemClassName', orderField: 'name', table: 'ItemClass' },
      {
        title: 'Und de Medida',
        field: 'criterionOfMeasurementSymbol',
        table: 'criterionOfMeasurement',
        orderField: 'symbol',
      },
      // {title: "Qtd Solicitada", field: "requestedQuantity"},
    ],
    filters: [
      {
        label: 'Código',
        param: 'code',
        type: 'text',
        placeholder: 'Digite o código',
      },
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
      {
        label: 'Tipo',
        param: 'idItemType',
        type: 'tipoItem',
        placeholder: 'Selecione o tipo',
      },

      {
        label: 'Critério de Medição',
        param: 'idCriterionOfMeasurement',
        type: 'criterioDeMedida',
        placeholder: 'Selecione o critério',
      },
    ],
  },
  // criado para deixar item imutável
  itemAcquisition: {
    title: 'Item',
    route: 'item',
    headers: [
      { title: 'Código', field: 'code' },
      { title: 'Nome', field: 'name' },
      { title: 'Classe', field: 'itemClassName', orderField: 'name', table: 'ItemClass' },
      { title: 'Und de Medida', field: 'criterionOfMeasurementSymbol' },
      { title: 'Quantidade', field: 'requestedQuantity', disableOrder: true },
    ],
    filters: [
      {
        label: 'Código',
        param: 'code',
        type: 'text',
        placeholder: 'Digite o código',
      },
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
      {
        label: 'Tipo',
        param: 'idItemType',
        type: 'tipoItem',
        placeholder: 'Selecione o tipo',
      },

      {
        label: 'Critério de Medição',
        param: 'idCriterionOfMeasurement',
        type: 'criterioDeMedida',
        placeholder: 'Selecione o critério',
      },
    ],
  },
  itemQuantity: {
    title: 'Item',
    route: 'itemQuantity',
    headers: [
      { title: 'Código', field: 'code' },
      { title: 'Nome', field: 'name', itemClass: '!text-wrap' },
      { title: 'Classe', field: 'itemClassName', orderField: 'name', table: 'ItemClass' },
      { title: 'Und de Medida', field: 'criterionOfMeasurementSymbol' },
      { title: 'Quantidade Total', field: 'totalQuantity' },
      { title: 'Quantidade', field: 'quantity', disableOrder: true },
    ],
    filters: [
      {
        label: 'Código',
        param: 'code',
        type: 'text',
        placeholder: 'Filtrar por código',
      },
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Filtrar por nome',
      },
      {
        label: 'Tipo',
        param: 'idItemType',
        type: 'tipoItem',
        placeholder: 'Filtrar por tipo',
      },

      {
        label: 'Critério de Medição',
        param: 'idCriterionOfMeasurement',
        type: 'criterioDeMedida',
        placeholder: 'Filtrar por critério de medição',
      },
    ],
  },
  itemQuantityInventory: {
    title: 'Item',
    route: 'itemQuantity',
    simpleSearch: true,
    itemAutocomplete: ['code', 'name'],
    headers: [
      { title: 'Código', field: 'code' },
      { title: 'Nome', field: 'name', itemClass: '!text-wrap' },
      { title: 'Classe', field: 'itemClassName', orderField: 'name', table: 'ItemClass' },
      { title: 'Und de Medida', field: 'criterionOfMeasurementSymbol' },
      { title: 'Quantidade Total', field: 'totalQuantity' },
    ],
    filters: [
      {
        label: 'Código',
        param: 'code',
        type: 'text',
        placeholder: 'Filtrar por código',
      },
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Filtrar por nome',
      },
      {
        label: 'Tipo',
        param: 'idItemType',
        type: 'tipoItem',
        placeholder: 'Filtrar por tipo',
      },

      {
        label: 'Critério de Medição',
        param: 'idCriterionOfMeasurement',
        type: 'criterioDeMedida',
        placeholder: 'Filtrar por critério de medição',
      },
    ],
  },
  itemQuantityMoviment: {
    title: 'Item',
    route: 'itemQuantity',
    simpleSearch: true,
    itemAutocomplete: ['code', 'name'],
    headers: [
      { title: 'Código', field: 'code' },
      { title: 'Nome', field: 'name', itemClass: '!text-wrap' },
      { title: 'Classe', field: 'itemClassName', orderField: 'name', table: 'ItemClass' },
      { title: 'Und de Medida', field: 'criterionOfMeasurementSymbol' },
      { title: 'Em Estoque', field: 'totalQuantity' },
      { title: 'Quantidade', field: 'quantity', disableOrder: true },
    ],
    filters: [
      {
        label: 'Código',
        param: 'code',
        type: 'text',
        placeholder: 'Filtrar por código',
      },
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Filtrar por nome',
      },
      {
        label: 'Tipo',
        param: 'idItemType',
        type: 'tipoItem',
        placeholder: 'Selecione o tipo',
      },

      {
        label: 'Critério de Medição',
        param: 'idCriterionOfMeasurement',
        type: 'criterioDeMedida',
        placeholder: 'Selecione o critério',
      },
    ],
  },
  itemNotInWarehouse: {
    title: 'Itens Fora do Estoque',
    route: 'item/notInWarehouse',
    headers: [
      { title: 'Código', field: 'code', raw: 'cast(code as SIGNED)' },
      { title: 'Nome', field: 'name', itemClass: '!text-wrap' },
      {
        title: 'Und de Medida',
        field: 'criterionOfMeasurementSymbol',
        table: 'criterion_of_measurement',
        orderField: 'symbol',
      },
      { title: 'Qtd Solicitada', field: 'requestedQuantity', disableOrder: true },
    ],
    filters: [
      {
        label: 'Código',
        param: 'code',
        type: 'text',
        placeholder: 'Filtrar por código',
      },
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Filtrar por nome',
      },
    ],
  },
  itemNotInWarehouseInventory: {
    title: 'Itens Fora do Estoque',
    route: 'item/notInWarehouse',
    headers: [
      { title: 'Código', field: 'code', raw: 'cast(code as SIGNED)' },
      { title: 'Classe', field: 'itemClassName', orderField: 'name', table: 'ItemClass' },
      { title: 'Nome', field: 'name', itemClass: '!text-wrap' },
      {
        title: 'Und de Medida',
        field: 'criterionOfMeasurementSymbol',
        table: 'criterion_of_measurement',
        orderField: 'symbol',
      },
    ],
    filters: [
      {
        label: 'Código',
        param: 'code',
        type: 'text',
        placeholder: 'Filtrar por código',
      },
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Filtrar por nome',
      },
    ],
  },
  inventoryType: {
    title: 'Tipo de Inventário',
    route: 'inventoryType',
    headers: [
      { title: 'Nome', field: 'name' },
      { title: 'Descrição', field: 'description' },
    ],
    filters: [
      {
        label: 'Código',
        param: 'code',
        type: 'text',
        placeholder: 'Digite o código',
      },
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
      {
        label: 'Tipo',
        param: 'idItemType',
        type: 'tipoItem',
        placeholder: 'Selecione o tipo',
      },

      {
        label: 'Critério de Medição',
        param: 'idCriterionOfMeasurement',
        type: 'criterioDeMedida',
        placeholder: 'Selecione o critério',
      },
    ],
  },
  vehicles: {
    title: 'Veículos',
    route: 'vehicles',
    headers: [
      { title: 'Placa', field: 'licensePlate' },
      { title: 'Modelo', field: 'model' },
      { title: 'Ano', field: 'yearOfManufacture' },
      { title: 'Condutor', field: 'conductorName', table: 'employee', orderField: 'name' },
      { title: 'Base', field: 'baseName', table: 'base', orderField: 'name' },
    ],
    filters: [
      {
        label: 'Prefixo',
        param: 'prefix',
        type: 'text',
        placeholder: 'Digite o prefixo',
      },
      {
        label: 'Placa',
        param: 'licensePlate',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite a placa',
      },
      {
        label: 'Tipo do Veículo',
        param: 'vehicleTypeId',
        type: 'text',
        placeholder: 'Selecione o tipo',
      },
      {
        label: 'Tipo de Uso do Veículo',
        param: 'vehicleUseTypeId',
        type: 'text',
        placeholder: 'Selecione o tipo de uso',
      },
      {
        label: 'Base',
        param: 'idBase',
        type: 'text',
        placeholder: 'Selecione a base',
      },
      {
        label: 'Condutor',
        param: 'idConductor',
        type: 'text',
        placeholder: 'Selecione o condutor',
      },
      {
        label: 'Tipo propriedade',
        param: 'ownershipType',
        type: 'select',
        items: [
          { label: 'Próprio', value: 'own' },
          { label: 'Terceiros', value: 'outsourced' },
        ],
        placeholder: 'Selecione o tipo de propriedade',
      },
      {
        label: 'Tipo de Combustível',
        param: 'fuelType',
        type: 'select',
        items: [
          { label: 'Álcool', value: 'alcohol' },
          { label: 'Diesel', value: 'diesel' },
          { label: 'Gasolina', value: 'gasoline' },
          { label: 'Álcool/Gasolina', value: 'flex' },
        ],
        placeholder: 'Selecione o combustível',
      },
      {
        label: 'Status',
        param: 'status',
        type: 'select',
        items: [
          { label: 'Ativo', value: 'active' },
          { label: 'Inativo', value: 'inactive' },
          { label: 'Em manutenção', value: 'maintenance' },
        ],
        placeholder: 'Selecione o status',
      },
    ],
  },
  chargeType: {
    title: 'Tipo de Encargo',
    route: 'chargeType',
    headers: [{ title: 'Nome', field: 'name' }],
    filters: [
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
    ],
  },
  constructionUnit: {
    title: 'Unidade Construtiva',
    route: 'constructionUnit',
    headers: [
      { title: 'Id', field: 'id' },
      { title: 'Obra', field: 'name' },
      { title: 'Quantidade', field: 'quantity' },
    ],
    filters: [
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
    ],
  },
  constructionProject: {
    title: 'Obras',
    route: 'constructionProject',
    headers: [
      { title: 'ID Obra', field: 'id' },
      { title: 'Protocolo', field: 'protocolo', format: formatProtocol },
      { title: 'Endereço', field: 'address' },
      { title: 'Responsável', field: 'monitorName', orderField: 'name', table: 'monitor' },
      { title: 'Status', field: 'status', format: formatConstructionStatus, disableOrder: true },
    ],
    filters: [
      {
        label: 'Protocolo',
        param: 'protocolo',
        type: 'text',
        operator: 'like',
        placeholder: 'Digite o protocolo',
      },
      {
        label: 'Endereço',
        param: 'address',
        type: 'text',
        operator: 'like',
        placeholder: 'Digite o endereço',
      },
      {
        label: 'Tipo',
        param: 'status',
        type: 'select',
        items: [
          { label: 'Em Aberto', value: 'open' },
          { label: 'Andamento', value: 'in_progress' },
          { label: 'Concluída', value: 'done' },
        ],
        placeholder: 'Selecione o status',
      },
      // status, endereco, order by proto desc
    ],
  },
  basis: {
    title: 'Bases',
    route: 'basis',
    headers: [{ title: 'Nome', field: 'name' }],
    simpleSearch: true,
    itemAutocomplete: ['name', 'id'],
    filters: [
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
    ],
  },
  local: {
    title: 'Locais',
    route: 'local',
    headers: [
      { title: 'Código', field: 'id' },
      { title: 'Nome', field: 'name' },
    ],
    filters: [
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
      {
        label: 'Unidade',
        param: 'idUnity',
        type: 'number',
        placeholder: 'Digite a unidade',
      },
    ],
  },
  unity: {
    title: 'Unidade',
    route: 'unity',
    headers: [
      { title: 'Código', field: 'id', width: '120px' },
      { title: 'Nome', field: 'name' },
    ],
    filters: [
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
    ],
  },
  resource: {
    title: 'Recurso',
    route: 'resource',
    headers: [
      { title: 'Código', field: 'id' },
      { title: 'Nome', field: 'name' },
      { title: 'Descrição', field: 'description' },
    ],
    filters: [
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
    ],
  },
  itemType: {
    title: 'Tipo de Item',
    route: 'itemType',
    simpleSearch: true,
    itemAutocomplete: ['code', 'name'],
    headers: [
      { title: 'Código', field: 'id' },
      { title: 'Nome', field: 'name' },
    ],
    filters: [
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
    ],
  },
  itemClass: {
    title: 'Classe de Item',
    route: 'itemClass',
    simpleSearch: true,
    itemAutocomplete: ['code', 'name'],
    headers: [
      { title: 'Código', field: 'id' },
      { title: 'Nome', field: 'name' },
    ],
    filters: [
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
    ],
  },
  district: {
    title: 'Distrito',
    route: 'district',
    headers: [
      { title: 'Código', field: 'id' },
      { title: 'Nome', field: 'name' },
      { title: 'Descrição', field: 'description' },
    ],
    filters: [
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome do distrito',
      },
    ],
  },
  supplier: {
    title: 'Fornecedor',
    route: 'supplier',
    headers: [
      { title: 'Nome', field: 'name', operator: 'like' },
      { title: 'CNPJ', field: 'cnpj' },
      { title: 'CEP', field: 'cep' },
      { title: 'Endereço', field: 'address', operator: 'like' },
      { title: 'Bairro', field: 'neighborhood', operator: 'like' },
      { title: 'Cidade', field: 'city', operator: 'like' },
      { title: 'E-mail', field: 'email', operator: 'like' },
      { title: 'Telefone', field: 'phoneNumber' },
    ],
    filters: [
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
      {
        label: 'CNPJ',
        param: 'cnpj',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o CNPJ',
      },
      {
        label: 'Endereço',
        param: 'address',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o endereço',
      },
      {
        label: 'Bairro',
        param: 'neighborhood',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o bairro',
      },
      {
        label: 'Cidade',
        param: 'city',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite a cidade',
      },
      {
        label: 'E-mail',
        param: 'email',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o e-mail',
      },
      {
        label: 'Telefone',
        param: 'phoneNumber',
        type: 'text',
        placeholder: 'Digite o telefone',
      },
    ],
  },
  vehicleType: {
    title: 'Tipo de veículo',
    route: 'vehicleType',
    headers: [{ title: 'Nome', field: 'name' }],
    simpleSearch: true,
    itemAutocomplete: ['name'],
    filters: [
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
    ],
  },
  vehicleUseType: {
    title: 'Tipo de Uso do Veículo',
    route: 'vehicleUseType',
    headers: [{ title: 'Nome', field: 'name' }],
    filters: [
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
    ],
  },
  vehicleTypeCharge: {
    title: 'Tipo de Encargo do Veículo',
    route: 'chargeType',
    headers: [{ title: 'Nome', field: 'name' }],
    filters: [
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
    ],
  },
  serviceMaintenance: {
    title: 'Serviço de manutenção',
    route: 'serviceMaintenance',
    headers: [{ title: 'Nome', field: 'name' }],
    simpleSearch: true,
    itemAutocomplete: ['name', 'id'],
    filters: [
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
    ],
  },
  workshop: {
    title: 'Oficinas',
    route: 'workshop',
    headers: [
      { title: 'Nome', field: 'name' },
      { title: 'Endereço', field: 'address' },
    ],
    filters: [
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
      {
        label: 'Endereço',
        param: 'address',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o endereço',
      },
    ],
  },
  chargeType: {
    title: 'Tipo de Encargo',
    route: 'chargeType',
    headers: [{ title: 'Nome', field: 'name' }],
    filters: [
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
    ],
  },
  maintenanceType: {
    title: 'Tipo de Manutenção',
    route: 'maintenanceType',
    headers: [{ title: 'Nome', field: 'name' }],
    itemAutocomplete: ['name', 'id'],
    filters: [
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
    ],
  },
  gasStation: {
    title: 'Postos de Gasolina',
    route: 'gasStation',
    headers: [
      { title: 'Nome', field: 'name' },
      { title: 'Endereço', field: 'address' },
    ],
    filters: [
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
      {
        label: 'Endereço',
        param: 'address',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o endereço',
      },
    ],
  },
  constructionProjectType: {
    title: 'Tipo de Obra',
    route: 'constructionProjectType',
    headers: [
      { title: 'Código', field: 'code' },
      { title: 'Nome', field: 'name' },
    ],
    filters: [
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
    ],
  },
  constructionProjectOs: {
    title: 'Protocolos da Obra',
    route: 'constructionProjectOs',
    headers: [
      { title: 'Código', field: 'id' },
      { title: 'Status', field: 'status' },
      { title: 'Tipo', field: 'type' },
      { title: 'Obra', field: 'idConstructionProject' },
      { title: 'Protocolo', field: 'protocolo' },
    ],
    filters: [
      {
        label: 'Status',
        param: 'status',
        type: 'text',
        placeholder: 'Digite o status',
      },
      {
        label: 'Tipo',
        param: 'typeName',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o tipo',
      },
      {
        label: 'Protocolo',
        param: 'protocolo',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o protocolo',
      },
    ],
  },
  constructionUnitType: {
    title: 'Tipo Unidade Construtiva',
    route: 'constructionUnitType',
    headers: [
      { title: 'Serviço', field: 'name' },
      { title: 'Código', field: 'id' },
    ],
    filters: [
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
    ],
  },
  microLocation: {
    title: 'Micro Local',
    route: 'microLocation',
    headers: [
      { title: 'Código', field: 'id' },
      { title: 'Nome', field: 'name' },
    ],
    filters: [
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
      {
        label: 'Tipo',
        param: 'type',
        type: 'select',
        items: [
          { label: 'Prateleira', value: 1 },
          { label: 'Estante', value: 2 },
          { label: 'Caixa', value: 3 },
          { label: 'Gaveta', value: 4 },
          { label: 'Palete', value: 5 },
          { label: 'Corredor', value: 6 },
          { label: 'Armário', value: 7 },
          { label: 'Seção Superior', value: 8 },
          { label: 'Seção Inferior', value: 9 },
          { label: 'Área de Estoque', value: 10 },
        ],
        placeholder: 'Selecione o tipo',
      },
    ],
  },
  contract: {
    title: 'Contratos',
    route: 'contract',
    headers: [
      { title: 'Código', field: 'id' },
      { title: 'Nome', field: 'name', itemClass: '!text-wrap' },
      { title: 'Descrição', field: 'description', itemClass: '!text-wrap' },
    ],
    simpleSearch: true,
    itemAutocomplete: ['name', 'id'],
    filters: [
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
    ],
  },
  serviceGroup: {
    title: 'Grupos de serviço',
    route: 'serviceGroup',
    headers: [
      { title: 'Código', field: 'id' },
      { title: 'Nome', field: 'name' },
      { title: 'Descrição', field: 'description' },
    ],
    filters: [
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
    ],
  },
  teamType: {
    title: 'Tipo de Equipe',
    route: 'teamType',
    headers: [
      { title: 'Código', field: 'id' },
      { title: 'Nome', field: 'name' },
      { title: 'Descrição', field: 'description' },
    ],
    filters: [
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
    ],
  },
  criterionOfMeasurement: {
    title: 'Unidade de Medida',
    route: 'criterionOfMeasurement',
    headers: [
      { title: 'ID', field: 'id' },
      { title: 'Nome', field: 'name' },
    ],
    filters: [
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
      {
        label: 'Símbolo',
        param: 'symbol',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o símbolo',
      },
    ],
  },
  employeeRole: {
    title: 'Cargo funcionário',
    route: 'employeeRole',
    headers: [{ title: 'Cargo', field: 'name' }],
    filters: [
      {
        label: 'Cargo',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o cargo',
      },
    ],
  },
  chargeType: {
    title: 'Tipo de Encargo',
    route: 'chargeType',
    headers: [{ title: 'Nome', field: 'name' }],
    filters: [
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
    ],
  },
  priceTable: {
    title: 'Tabela de preços',
    route: 'priceTable',
    headers: [{ title: 'Nome', field: 'name' }],
    filters: [
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
    ],
  },
  emailSendingList: {
    title: 'Lista de envio',
    route: 'emailSendingList',
    headers: [{ title: 'Nome', field: 'name' }],
    filters: [
      {
        label: 'Nome',
        param: 'name',
        operator: 'like',
        type: 'text',
        placeholder: 'Digite o nome',
      },
    ],
  },
  street: {
    title: 'Logradouro',
    route: 'street',
    headers: [
      { title: 'Código', field: 'code', raw: 'cast(street.code as SIGNED)' },
      { title: 'Nome', field: 'name' },
    ],
    filters: [
      { label: 'CÃ³digo', param: 'code', operator: 'like', type: 'text', placeholder: 'Digite o cÃ³digo do logradouro' },
      { label: 'Nome', param: 'name', operator: 'like', type: 'text', placeholder: 'Digite o nome do logradouro' },
      { label: 'Localidade', param: 'localName', operator: 'like', type: 'text', placeholder: 'Digite o nome da localidade' },
    ],
    order: [{ title: 'Código', column: 'code', raw: 'cast(street.code as SIGNED)' }],
  },
  neighborhood: {
    title: 'Bairro',
    route: 'neighborhood',
    headers: [
      { title: 'Bairro', field: 'name' },
      { title: 'Localidade', field: 'localName' },
    ],
    filters: [
      { label: 'Bairro', param: 'name', operator: 'like', type: 'text', placeholder: 'Digite o nome do bairro' },
      {
        label: 'Localidade',
        param: 'idLocal',
        operator: '=',
        type: 'zoom',
        database: 'local',
        itemValue: 'id',
        itemText: 'name',
        placeholder: 'Selecione a localidade',
      },
    ],
  },
  sector: {
    title: 'Setor',
    route: 'sector',
    headers: [
      { title: 'Código', field: 'id' },
      { title: 'Nome', field: 'name' },
    ],
    filters: [{ label: 'Nome', param: 'name', operator: 'like', type: 'text', placeholder: 'Digite o nome do setor' }],
  },
}

export default base
